import React, { FC } from 'react';
import styled from 'styled-components';
import { Header } from '@homeproved/com/feature-header';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { Footer } from '@homeproved/com/feature-footer';

type PageShellProps = {
  padding?: boolean;
  innerPadding?: boolean;
  footerMargin?: number;
  fullWidth?: boolean;
  omitFooter?: boolean;
  omitHeader?: boolean;
  relative?: boolean;
  tabsMenu?: boolean;
  gradient?: boolean;
};

const Wrapper = styled(({ ...restProps }) => <div {...restProps} />)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const ContentWrapper = styled(({ gradient, innerPadding, relative, ...restProps }) => <div {...restProps} />)`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: flex-start;
  padding: 0 ${({ innerPadding }) => innerPadding && '2rem'};
  width: 100%;
  background: ${({ theme, gradient }) => gradient ? theme.config.gradients.vertical : "#fff"};
;
  ${({ relative }) => relative && `position: relative;`}
`;

const Inner = styled(({ padding, isMobile, fullWidth, ...restProps }) => <div {...restProps} />)`
  width: 100%;
  max-width: ${({ fullWidth }) => (fullWidth ? 'none' : '115.6rem')};
  padding-top: ${({ padding, isMobile }) => (padding ? (isMobile ? '2rem' : '6rem') : '')};
  align-self: stretch;
  display: flex;
  flex-direction: column;
`;

export const PageShell: FC<PageShellProps> = ({
  padding = true,
  gradient = false,
  innerPadding = true,
  children,
  footerMargin = 6,
  fullWidth = false,
  omitFooter = false,
  omitHeader = false,
  relative = false,
  tabsMenu = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.xs));

  return (
    <Wrapper>
      {!omitHeader && <Header gradient={gradient} />}
      <ContentWrapper gradient={gradient} innerPadding={innerPadding} relative={relative}>
        <Inner padding={padding} fullWidth={fullWidth} isMobile={isMobile}>
          {children}
        </Inner>
      </ContentWrapper>
      {!omitFooter && <Footer marginTop={footerMargin} />}
    </Wrapper>
  );
};
